import request from '../utils/Request';
import { Methods } from '../config';

const baseURL = 'bi/base/writeback';

const biWritebackService = {
  getTables: () => {
    return request({
      method: Methods.GET,
      resource: `${baseURL}/tables`,
    });
  },

  getTableFields: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/tableFields`,
      data,
    });
  },

  getCurrentValues: (writebackId, data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/${encodeURIComponent(writebackId)}/current`,
      data,
    });
  },

  updateValues: (writebackId, data) => {
    return request({
      method: Methods.PUT,
      resource: `${baseURL}/${encodeURIComponent(writebackId)}`,
      data,
    });
  },
};

export default biWritebackService;
